module.exports = __webpack_public_path__ + "static/media/eek9.871a769a.JPG";